import { AssetSubCategory, AssetSubCategoryJSON } from "./AssetSubCategory";

export type AssetCategoryJSON = {
  id?: number;
  category?: string;
  sequence?: number;
  sub_categories?: AssetSubCategoryJSON[];
};

export class AssetCategory {
  constructor(
    public id?: number,
    public category?: string,
    public sequence?: number,
    public sub_categories?: AssetSubCategory[]
  ) {}
  static fromJSON = (json: AssetCategoryJSON): AssetCategory => {
    return new AssetCategory(
      json.id,
      json.category,
      json.sequence,
      json.sub_categories
        ? json.sub_categories?.map((json2: AssetSubCategoryJSON) =>
            AssetSubCategory.fromJSON(json2)
          )
        : undefined
    );
  };
}
